import { Form, Flex, Input, Select, Button, Space, Divider, Row, Col, message, Checkbox } from "antd";
import { citysList } from "../states/citys";
import {
  userRole,
  userTutorCityAccess,
  userStudentCityAccess,
  userShadowTutorCityAccess,
  userStudentCityAssignmentAccess,
  userTutorCityAssignmentAccess,
} from "../states/userRole";
import { useAtom } from "jotai";
import axiosInstance from "../axios";
import log from "../logger";
import { CopyOutlined } from "@ant-design/icons";

/* eslint-disable @typescript-eslint/no-unused-vars */
function CreateCre() {
  const [form] = Form.useForm();
  const [citys, _setCitys] = useAtom(citysList);
  const [role, _setRole] = useAtom(userRole);
  const [tutorCityAccess, _setTutorCityAccess] = useAtom(userTutorCityAccess);
  const [studentCityAccess, _setStudentCityAccess] = useAtom(userStudentCityAccess);
  const [shadowTutorCityAccess, _setShadowTutorCityAccess] = useAtom(userShadowTutorCityAccess);
  const [studentCityAssignmentAccess, _setStudentCityAssignmentAccess] = useAtom(userStudentCityAssignmentAccess);
  const [tutorCityAssignmentAccess, _setTutorCityAssignmentAccess] = useAtom(userTutorCityAssignmentAccess);

  const onFinish = async (values: Record<string, unknown>) => {
    axiosInstance
      .post("/v1/cre/user", values)
      .then((res) => {
        const { is_success, data, error } = res.data;
        if (is_success) {
          message.success({
            content: (
              <div>
                Password: <b>{data}</b>{" "}
                <CopyOutlined className="copy" onClick={() => navigator.clipboard.writeText(data)} />
                <Button
                  type="link"
                  size="small"
                  style={{ padding: "3px", marginLeft: "15px" }}
                  onClick={() => message.destroy()}
                >
                  X
                </Button>
              </div>
            ),
            // duration: 0,
          });
          form.resetFields();
        } else {
          log.debug(error);
          message.error(error, 5, () => message.destroy());
        }
      })
      .catch((err) => {
        log.debug(err);
      });
  };

  return (
    <Form
      form={form}
      layout="vertical"
      name="nest-messages"
      style={{
        width: "95%",
        margin: "10px auto",
      }}
      onFinish={onFinish}
      initialValues={{ user_type: "Superviser" }}
    >
      <Divider>User Details</Divider>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name={["user_details", "email"]}
            label="Email"
            rules={[
              {
                type: "email",
                message: "The input is not valid E-mail!",
              },
              {
                required: true,
                message: "Please input your E-mail!",
              },
            ]}
          >
            <Input placeholder="Email" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name={["user_details", "first_name"]}
            label="Full Name"
            rules={[
              {
                required: true,
                message: "Please input your Full Name!",
              },
            ]}
          >
            <Input placeholder="Full Name" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name={["user_details", "phone"]}
            label="Phone No"
            rules={[
              {
                required: true,
                message: "Please input your Phone No!",
              },
              {
                pattern: /^[6-9]\d{9}$/,
                message: "Enter a valid Indian phone number!",
              },
            ]}
          >
            <Input placeholder="Phone No" type="number" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name={["user_details", "user_type"]}
            label="Role"
            rules={[
              {
                required: true,
                message: "Please select your role!",
              },
            ]}
          >
            <Select placeholder="Select Role">
              {role === "Superadmin" && <Select.Option value="Admin">Admin</Select.Option>}
              <Select.Option value="Superviser">Superviser</Select.Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Divider>Access Details</Divider>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name={["access_details", "student"]} label="Parents City">
            <Select showSearch optionFilterProp="children" mode="multiple" placeholder="Select City">
              {role !== "Superadmin"
                ? studentCityAccess?.map((city_id) => (
                    <Select.Option key={city_id} value={city_id}>
                      {(citys as { [key: number]: string })[city_id]}
                    </Select.Option>
                  ))
                : (Object.keys(citys) as unknown as number[]).map((city_id) => (
                    <Select.Option key={city_id} value={city_id}>
                      {(citys as { [key: number]: string })[city_id]}
                    </Select.Option>
                  ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name={["access_details", "tutor"]} label="Tutors City">
            <Select showSearch optionFilterProp="children" mode="multiple" placeholder="Select City">
              {role !== "Superadmin"
                ? (tutorCityAccess as number[])?.map((city_id) => (
                    <Select.Option key={city_id} value={city_id}>
                      {(citys as { [key: number]: string })[city_id]}
                    </Select.Option>
                  ))
                : (Object.keys(citys) as unknown as number[]).map((city_id) => (
                    <Select.Option key={city_id} value={city_id}>
                      {(citys as { [key: number]: string })[city_id]}
                    </Select.Option>
                  ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name={["access_details", "student_city_assignment"]} label="Student City Assignment">
            <Select showSearch optionFilterProp="children" mode="multiple" placeholder="Select City">
              {role !== "Superadmin"
                ? studentCityAssignmentAccess?.map((city_id) => (
                    <Select.Option key={city_id} value={city_id}>
                      {citys[city_id]}
                    </Select.Option>
                  ))
                : (Object.keys(citys) as unknown as number[]).map((city_id) => (
                    <Select.Option key={city_id} value={city_id}>
                      {(citys as { [key: number]: string })[city_id]}
                    </Select.Option>
                  ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name={["access_details", "tutor_city_assignment"]} label="Tutor City Assignment">
            <Select showSearch optionFilterProp="children" mode="multiple" placeholder="Select City">
              {role !== "Superadmin"
                ? tutorCityAssignmentAccess?.map((city_id) => (
                    <Select.Option key={city_id} value={city_id}>
                      {citys[city_id]}
                    </Select.Option>
                  ))
                : (Object.keys(citys) as unknown as number[]).map((city_id) => (
                    <Select.Option key={city_id} value={city_id}>
                      {(citys as { [key: number]: string })[city_id]}
                    </Select.Option>
                  ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name={["access_details", "shadow_tutor"]} label="Shadow Tutors City">
            <Select showSearch optionFilterProp="children" mode="multiple" placeholder="Select City">
              {role !== "Superadmin"
                ? shadowTutorCityAccess?.map((city_id) => (
                    <Select.Option key={city_id} value={city_id}>
                      {citys[city_id]}
                    </Select.Option>
                  ))
                : (Object.keys(citys) as unknown as number[]).map((city_id) => (
                    <Select.Option key={city_id} value={city_id}>
                      {(citys as { [key: number]: string })[city_id]}
                    </Select.Option>
                  ))}
            </Select>
          </Form.Item>
        </Col>
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.user_details?.user_type !== currentValues.user_details?.user_type
          }
        >
          {({ getFieldValue }) =>
            role === "Superadmin" &&
            getFieldValue(["user_details", "user_type"]) !== "Admin" && (
              <>
                <Col span={6}>
                  <Form.Item name={["access_details", "online_tutor_city"]} label=" " valuePropName="checked">
                    <Checkbox>Online tutor city</Checkbox>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name={["access_details", "online_tutor_assignment"]} label=" " valuePropName="checked">
                    <Checkbox>Online tutor assignment</Checkbox>
                  </Form.Item>
                </Col>
              </>
            )
          }
        </Form.Item>
      </Row>
      <Form.Item name={["access_details", "is_transfer_payment"]} valuePropName="checked" colon={false}>
        <Checkbox><span>Is Transfer Payment</span></Checkbox>
      </Form.Item>
      <Form.Item>
        <Flex justify="center" align="center">
          <Space>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
            <Button htmlType="button" onClick={() => form.resetFields()}>
              Reset
            </Button>
          </Space>
        </Flex>
      </Form.Item>
    </Form>
  );
}

export default CreateCre;
